@if (deployed) {
  @for (alert of alertService.alertList; track alert) {
    @if (alert.active && deployed) {
      <div class="notification">
        <app-toaster id="digestion-info" [alert]="alert">
          {{ alert.message }}
          @if (alert.complement.length > 0) {
            <br />{{ alert.complement }}
          }
        </app-toaster>
      </div>
    }
  }
}

@if (alertService.getListSize()) {
  <div class="menu">
    <app-wbce-button class="full-width" (click)="deployNotification()">
      <mat-icon
        inline
        fontSet="fa"
        [fontIcon]="!deployed ? 'fa-angle-down' : 'fa-angle-up'"
        >
      </mat-icon>
      @if (!deployed) {
        <div class="counter">
          {{ alertService.getListSize() }}
        </div>
      }
    </app-wbce-button>
  </div>
}
